module.exports = __webpack_public_path__ + "static/media/erwinbeets.edacf2d7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/erwinbeets.webp
// module id = 384
// module chunks = 0